/* Vue sur Mur : interactions (apparitions, lés, index, schéma, défilé, méga-menu). Sans dépendance. */
(() => {
  const root = document.documentElement;
  window.VSM_READY = true;
  root.classList.add('vsm-js');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = window.matchMedia('(min-width: 1000px)');

  /* ---------- Titres : une ligne masquée par titre si non découpé ---------- */
  document.querySelectorAll('[data-split]').forEach((el) => {
    if (el.querySelector('.vsm-line')) return;
    const inner = el.innerHTML;
    el.innerHTML = `<span class="vsm-line" style="--i:0"><span>${inner}</span></span>`;
  });

  /* ---------- Apparitions ---------- */
  const targets = document.querySelectorAll('[data-reveal], [data-split], [data-les], .vsm-hero, .vsm-final');
  const show = (el) => {
    el.classList.add('is-in');
    if (el.matches('[data-les]')) setTimeout(() => el.classList.add('is-joined'), reduce ? 0 : 1900);
    if (el.matches('.vsm-hero')) el.classList.add('is-ready');
  };
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(show);
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach((el) => io.observe(el));
  }

  /* ---------- En-tête : ombre au défilement ---------- */
  const onScrollHeader = () => root.classList.toggle('vsm-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  /* ---------- Index des styles : aperçu qui suit le curseur ---------- */
  document.querySelectorAll('[data-vsm-index]').forEach((sec) => {
    const list = sec.querySelector('.vsm-index');
    const float = sec.querySelector('.vsm-index__float');
    if (!list || !float) return;
    const imgs = float.querySelectorAll('img');
    let tx = 0, ty = 0, x = 0, y = 0, vx = 0, raf = null, on = false;
    const w = () => float.offsetWidth, h = () => float.offsetHeight;
    const loop = () => {
      const nx = x + (tx - x) * 0.14, ny = y + (ty - y) * 0.14;
      vx = nx - x; x = nx; y = ny;
      float.style.setProperty('--x', `${x}px`);
      float.style.setProperty('--y', `${y}px`);
      float.style.setProperty('--r', `${Math.max(-8, Math.min(8, vx * 0.35))}deg`);
      raf = on || Math.abs(tx - x) > 0.5 ? requestAnimationFrame(loop) : null;
    };
    list.addEventListener('pointermove', (ev) => {
      if (ev.pointerType !== 'mouse') return;
      tx = ev.clientX + 28; ty = ev.clientY - h() / 2;
      if (tx + w() > window.innerWidth - 12) tx = ev.clientX - w() - 28;
      if (!raf) { if (!on) { x = tx; y = ty; } raf = requestAnimationFrame(loop); }
    });
    list.querySelectorAll('.vsm-index__link').forEach((a) => {
      a.addEventListener('pointerenter', (ev) => {
        if (ev.pointerType !== 'mouse') return;
        const i = a.dataset.index;
        imgs.forEach((im) => im.classList.toggle('is-active', im.dataset.index === i));
        on = true; float.classList.add('is-on');
        if (!raf) raf = requestAnimationFrame(loop);
      });
    });
    list.addEventListener('pointerleave', () => { on = false; float.classList.remove('is-on'); });
  });

  /* ---------- Comment ça marche : le schéma suit la lecture ---------- */
  document.querySelectorAll('[data-vsm-steps]').forEach((sec) => {
    const diagram = sec.querySelector('.vsm-steps__diagram');
    const items = sec.querySelectorAll('[data-step-item]');
    if (!diagram || !items.length) return;
    const set = (n) => {
      diagram.dataset.step = n;
      items.forEach((it) => it.classList.toggle('is-active', it.dataset.stepItem === String(n)));
    };
    set(1);
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) set(e.target.dataset.stepItem); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    items.forEach((it) => io.observe(it));
  });

  /* ---------- Défilé : épinglé et horizontal sur ordinateur ---------- */
  document.querySelectorAll('[data-vsm-rail]').forEach((sec) => {
    const pin = sec.querySelector('.vsm-rail__pin');
    const track = sec.querySelector('[data-rail-track]');
    const viewport = sec.querySelector('.vsm-rail__viewport');
    const cur = sec.querySelector('[data-rail-current]');
    const bar = sec.querySelector('[data-rail-bar]');
    const items = track ? track.children : [];
    if (!track) return;
    let shift = 0;
    const total = Math.max(1, items.length - 1);
    const layout = () => {
      if (desktop.matches && !reduce) {
        sec.classList.add('is-pinned');
        shift = Math.max(0, track.scrollWidth - viewport.clientWidth);
        sec.style.height = `${pin.offsetHeight + shift}px`;
      } else {
        sec.classList.remove('is-pinned');
        sec.style.height = '';
        track.style.transform = '';
      }
      update();
    };
    const update = () => {
      let p;
      if (sec.classList.contains('is-pinned')) {
        const r = sec.getBoundingClientRect();
        const top = parseFloat(getComputedStyle(pin).top) || 0;
        p = Math.min(1, Math.max(0, (top - r.top) / Math.max(1, shift)));
        track.style.transform = `translate3d(${-p * shift}px,0,0)`;
      } else {
        p = viewport.scrollLeft / Math.max(1, viewport.scrollWidth - viewport.clientWidth);
      }
      const n = Math.min(total, Math.round(p * total) + 1);
      if (cur) cur.textContent = String(n).padStart(2, '0');
      if (bar) bar.parentElement.style.setProperty('--p', Math.max(0.08, p));
      if (bar) bar.style.setProperty('--p', Math.max(0.08, p));
    };
    window.addEventListener('scroll', update, { passive: true });
    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', layout);
    desktop.addEventListener?.('change', layout);
    if (document.readyState === 'complete') layout(); else window.addEventListener('load', layout);
    layout();
  });

  /* ---------- Méga-menu : survol, trois lés, décors, parallaxe ---------- */
  const loadImgs = (scope) => scope.querySelectorAll('img[data-src]').forEach((im) => {
    if (im.dataset.srcset) { im.srcset = im.dataset.srcset; im.removeAttribute('data-srcset'); }
    im.src = im.dataset.src; im.removeAttribute('data-src');
  });
  document.querySelectorAll('dropdown-component.vsm-mega-item').forEach((dd) => {
    const panel = dd.querySelector('.vsm-mega');
    if (!panel) return;
    const links = [...panel.querySelectorAll('.vsm-mega__link, .vsm-mega__link--hub')];
    const scenes = [...panel.querySelectorAll('.vsm-mega__scene')];
    const sets = [...panel.querySelectorAll('.vsm-mega__thumbset')];
    const stage = panel.querySelector('.vsm-mega__stage');
    let current = 'hub', loaded = false;
    const ensure = () => { if (!loaded) { loaded = true; loadImgs(panel); } };
    const idle = window.requestIdleCallback || ((f) => setTimeout(f, 2500));
    window.addEventListener('load', () => idle(ensure), { once: true });
    const activate = (key) => {
      if (key === current) return;
      const prev = scenes.find((sc) => sc.dataset.i === current), next = scenes.find((sc) => sc.dataset.i === key);
      links.forEach((l) => l.classList.toggle('is-active', l.dataset.i === key && key !== 'hub'));
      sets.forEach((st) => st.classList.toggle('is-active', st.dataset.i === key));
      // Une seule scène reste dessous (la précédente, posée en entier) ; toutes les autres disparaissent tout de suite.
      // Évite l'empilement de lés de plusieurs décors quand la souris passe vite sur la liste.
      scenes.forEach((sc) => {
        if (sc === prev || sc === next) return;
        clearTimeout(sc._vsmT); sc.classList.remove('is-active', 'is-leaving');
      });
      if (prev) {
        clearTimeout(prev._vsmT);
        prev.classList.remove('is-active'); prev.classList.add('is-leaving');
        prev._vsmT = setTimeout(() => { if (prev.dataset.i !== current) prev.classList.remove('is-leaving'); }, reduce ? 0 : 1400);
      }
      if (next) { clearTimeout(next._vsmT); next.classList.remove('is-leaving'); void next.offsetWidth; next.classList.add('is-active'); }
      current = key;
    };
    // Petite intention de survol : on ne change de décor que si la souris s'arrête un instant sur le lien
    let hoverT;
    links.forEach((a) => {
      a.addEventListener('pointerenter', () => { ensure(); clearTimeout(hoverT); hoverT = setTimeout(() => activate(a.dataset.i), 70); });
      a.addEventListener('pointerleave', () => clearTimeout(hoverT));
      a.addEventListener('focus', () => { ensure(); clearTimeout(hoverT); activate(a.dataset.i); });
    });
    // À la fermeture, on revient sur la vue d'ensemble « papier peint panoramique »
    new MutationObserver(() => { if (dd.getAttribute('data-open') !== 'true') setTimeout(() => { if (dd.getAttribute('data-open') !== 'true') activate('hub'); }, 800); }).observe(dd, { attributes: true, attributeFilter: ['data-open'] });
    if (stage && !reduce) {
      stage.addEventListener('pointermove', (ev) => {
        const r = stage.getBoundingClientRect();
        const x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        stage.style.setProperty('--px', `${(-x * 18).toFixed(1)}px`);
        stage.style.setProperty('--py', `${(-y * 12).toFixed(1)}px`);
      });
      stage.addEventListener('pointerleave', () => { stage.style.setProperty('--px', '0px'); stage.style.setProperty('--py', '0px'); });
    }
    let t;
    const header = dd.closest('header-component') || dd.parentElement;
    dd.addEventListener('pointerenter', (ev) => {
      if (ev.pointerType !== 'mouse' || !desktop.matches) return;
      ensure(); clearTimeout(t);
      t = setTimeout(() => { if (dd.getAttribute('data-open') !== 'true') { dd.closest('dropdown-group-component')?.closeAllDropdowns?.(); dd.open?.(); } }, 120);
    });
    // Sur ordinateur, le survol ouvre déjà le menu : un clic sur l'entrée mène à la collection (au lieu de refermer)
    const toggle = dd.querySelector('[data-ref="dropdown-toggle"]');
    dd.addEventListener('click', (ev) => {
      if (!toggle || !toggle.contains(ev.target)) return;
      ensure();
      if (!desktop.matches || !window.matchMedia('(hover: hover)').matches) return;
      ev.stopPropagation(); ev.preventDefault();
      if (dd.getAttribute('data-open') === 'true' && dd.dataset.url) { window.location.href = dd.dataset.url; }
      else { dd.closest('dropdown-group-component')?.closeAllDropdowns?.(); dd.open?.(); }
    }, true);
    header.addEventListener('pointerleave', (ev) => {
      if (ev.pointerType !== 'mouse') return;
      clearTimeout(t); t = setTimeout(() => dd.close?.(), 260);
    });
    panel.addEventListener('pointerenter', () => clearTimeout(t));
    document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape') dd.close?.(); });
  });
})();
